/* eslint-disable no-param-reassign */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { withAnalytics } from '@veneer/analytics';
import { Card } from '@veneer/core';
import React, { memo } from 'react';
import './styles.scss';
import { ActionCardProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit :  Action Card
 * @public
 */
const TActionCard: React.FC<ActionCardProps> = ({
  id = generateID('clientos-ui-toolkit-action-card'),
  header,
  subheader,
  endContent,
  onCardClick,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  logotype,
  disabled = false,
  background
}) => {
  return (
    <Card
      id={id}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      onClick={disabled ? undefined : onCardClick}
      className={`clientos-ui-toolkit-action-card${disabled ? ' disabled' : ''}`}
      style={background ? { backgroundImage: `url(${background})` } : {}}
      tabIndex={disabled ? -1 : 0}
      content={
        <div
          className="clientos-ui-toolkit-action-card__container"
          id={`${id}__container`}
        >
          <div
            className="clientos-ui-toolkit-action-card__container__text-container"
            id={`${id}__text-container`}
            aria-live="polite"
          >
            <h2
              className="clientos-ui-toolkit-action-card__container__text-container__header subtitle-large-medium"
              aria-label={header}
              role="text"
              id={`${id}__header`}
            >
              {logotype ? <img src={logotype} /> : header}
            </h2>
            <h3
              className="clientos-ui-toolkit-action-card__container__text-container__subheader body-regular"
              aria-label={subheader}
              role="text"
              id={`${id}__subheader`}
            >
              {subheader ? subheader : ' '}
            </h3>
          </div>
          {endContent && (
            <div
              className="clientos-ui-toolkit-action-card__container__icon-image-container"
              id={`${id}__icon`}
            >
              {endContent}
            </div>
          )}
        </div>
      }
    />
  );
};

export const ActionCardWithAnalytics = withAnalytics(TActionCard);
export type { ActionCardProps };
export default memo(TActionCard);
